import {AdNetworkCallbackStatus, AdNetworkEventType, AdNetworkLogListRequest} from "../../http/protocol";

/** Parse a comma-separated condition input into a trimmed, blank-free list (or undefined when empty). */
export const toConditionList = (value: string): string[] | undefined => {
    const items = value.split(",").map(s => s.trim()).filter(s => s.length > 0);
    return items.length > 0 ? items : undefined;
};

export const fromConditionList = (value?: string[]): string => (value ? value.join(", ") : "");

export interface LogFilter {
    page: number;
    size: number;
    userId: string;
    eventType: AdNetworkEventType | "";
    status: AdNetworkCallbackStatus | "";
}

/** Map the log-viewer filter state to an API request, omitting empty/non-numeric filters. */
export const buildLogRequest = (filter: LogFilter): AdNetworkLogListRequest => ({
    page: filter.page,
    size: filter.size,
    userId: filter.userId.trim() !== "" && !isNaN(Number(filter.userId)) ? Number(filter.userId) : undefined,
    eventType: filter.eventType === "" ? undefined : filter.eventType,
    status: filter.status === "" ? undefined : filter.status
});

/** Narrowly extract a server error message from an unknown rejection (axios-style) without using `any`. */
export const errorMessage = (e: unknown, fallback: string): string => {
    if (typeof e === "object" && e !== null) {
        const data = (e as {response?: {data?: unknown}}).response?.data;
        if (typeof data === "string" && data.length > 0) {
            return data;
        }
    }
    return fallback;
};
